import { type ReactNode, useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import { AppPhase, useAppPhaseStore } from './store/AppPhaseStore';
import { useSessionStore } from './store/SessionStore';
import { useResourceStore } from './store/ResourceStore';
import { setApiRoutes } from './store/ApiRoutes';
import { ProductionApiRoutes } from './store/apiRoutes/ProductionApiRoutes';
import { OfflineApiRoutes } from './store/apiRoutes/OfflineApiRoutes';
import { getEnvStore } from './store/EnvStore';
import usePersistentStore from '@gui/store/persistent/persistentStore';
import { identifySentryUser } from './sentry';
import { CapabilitiesProvider, NORMAL_CAPABILITIES } from './demo/capabilities';

export default function AppBootstrap({ children }: { children: ReactNode }) {
    const phase = useAppPhaseStore((s) => s.phase);
    const routes = getEnvStore().env === 'local-offline' ? OfflineApiRoutes : ProductionApiRoutes;

    setApiRoutes(routes);

    useEffect(() => {
        (async () => {
            await useSessionStore.getState().authenticate();
            if (useSessionStore.getState().status !== 'authenticated') return;

            await useResourceStore.getState().fetchResources();
            usePersistentStore.persist.rehydrate();
            identifySentryUser();
        })();
    }, []);

    if (phase === AppPhase.BOOT || phase === AppPhase.AUTHENTICATING || phase === AppPhase.LOADING_RESOURCES) {
        return (
            <CircularProgress
                size={100}
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                }}
            />
        );
    }

    return <CapabilitiesProvider capabilities={NORMAL_CAPABILITIES}>{children}</CapabilitiesProvider>;
}
